"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelector = exports.callAll = exports.numberToPx = void 0;
exports.numberToPx = (value) => {
    if (typeof value === 'number') {
        return `${value}px`;
    }
    if (!value) {
        return `0px`;
    }
    return value;
};
exports.callAll = (...fns) => (...args) => fns.forEach((fn) => fn && fn(...args));
const NO_SELECTOR = 'NO_COMPONENT_SELECTOR';
function isStyledComponent(comp) {
    return Boolean(comp && typeof comp.styledComponentId === 'string');
}
function isEmotion(comp) {
    return Boolean(comp && comp.__emotion_real);
}
function isReuse(comp) {
    return Boolean(comp && Array.isArray(comp.uses));
}
function hasSelector(comp) {
    return Boolean(comp && typeof comp.selector === 'string');
}
function getSelector(comp) {
    if (typeof comp === 'string') {
        return `.${comp}`;
    }
    if (isStyledComponent(comp)) {
        return `.${comp.styledComponentId}`;
    }
    if (isEmotion(comp)) {
        return comp.toString();
    }
    if (isReuse(comp)) {
        return comp.uses
            .filter((x) => typeof x !== 'string')
            .map(getSelector)
            .filter((x) => x && x !== NO_SELECTOR)
            .join('');
    }
    if (hasSelector(comp)) {
        return comp.selector;
    }
    return NO_SELECTOR;
}
exports.getSelector = getSelector;

//# sourceMappingURL=utils.js.map
